import AuthChecker from "../../components/authChecker";
import { Tag, Flex, Image, Tooltip, message } from "antd";
import { AiOutlineCopy } from "react-icons/ai";
import routes from "../../constants/routes";
import { Link } from "react-router-dom";
import roleAndPermissions from "../../constants/permissions";
import dayjs from "dayjs";

const discounts = [
  {
    identifier: "code",
    label: "Name",
    allowedFilters: [
      {
        id: "$eqc",
        name: "Equals",
        valueField: "text",
      },
      {
        id: "$nec",
        name: "Not Equals",
        valueField: "text",
      },
      {
        id: "$startsWithc",
        name: "Starts With",
        valueField: "text",
      },
      {
        id: "$endsWithc",
        name: "Ends With",
        valueField: "text",
      },
      {
        id: "$containsc",
        name: "Contains",
        valueField: "text",
      },
      {
        id: "$notContainsc",
        name: "Does Not Contain",
        valueField: "text",
      },
    ],
    displayDefault: true,
    render: (value, record, index) => {
      return (
        <AuthChecker
          notPermissionCase={
            <Flex align="center" gap={8}>
              {/* <Image
                width={40}
                src={record?.image?.[0]?.url}
                fallback="data:image/png;base64,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"
                preview={false}
                className="table-cell-product-image"
              /> */}
              {record?.code}
            </Flex>
          }
          permissions={[roleAndPermissions.DiscountManagement.update]}
        >
          <Flex align="center" gap={8}>
            <Link
              to={routes.EDIT_DISCOUNT.path.replace(":id", record.id)}
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <Flex align="center" gap={8}>
                {/* <Image
                  width={40}
                  src={record.image?.[0]?.url}
                  // src={ record?.image?.[0]?.url ? record?.image?.[0]?.url : record.variations?.[0]?.images?.[0]?.url}
                  fallback="data:image/png;base64,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"
                  preview={false}
                  className="table-cell-product-image"
                /> */}

                <b>{record?.code}</b>
              </Flex>
            </Link>
            {!record?.is_automatic && (
              <Tooltip title="Copy Code" placement="right">
                <AiOutlineCopy
                  size={14}
                  onClick={(e) => {
                    e.stopPropagation();
                    navigator.clipboard.writeText(record?.code);
                    message.success("Copied to clipboard");
                  }}
                  style={{ cursor: "pointer" }}
                />
              </Tooltip>
            )}
          </Flex>
        </AuthChecker>
      );
    },
  },
  {
    identifier: "active",
    label: "Status",
    allowedFilters: [
      {
        id: "$eq",
        name: "Equals",
        valueField: "select",
        selectOptions: {
          Active: true,
          Inactive: false,
        },
      },
    ],
    displayDefault: true,
    render: (value, record, index) => {
      return (
        <Tag color={value ? "green" : "red"} className="status-tag">
          {value ? "ACTIVE" : "INACTIVE"}
        </Tag>
      );
    },
  },
  {
    identifier: "is_automatic",
    label: "Method",
    allowedFilters: [
      {
        id: "$eq",
        name: "Equals",
        valueField: "select",
        selectOptions: {
          Automatic: true,
          Code: false,
        },
      },
    ],
    displayDefault: true,
    render: (value, record, index) => {
      return <>{record?.is_automatic ? "Automatic" : "Code"}</>;
    },
  },
  {
    identifier: "type",
    label: "Type",
    allowedFilters: [],
    displayDefault: true,
    render: (value, record, index) => {
      return (
        <>
          <strong>{record?.schema}</strong>
          <br />
          <span>
            {record?.apply_to === "product"
              ? "Product discount"
              : record?.apply_to === "collection"
              ? "Catalog discount"
              : record?.apply_to === "category"
              ? "Category Discount"
              : ""}
          </span>
        </>
      );
    },
  },
  // {
  //   identifier: "combinations",
  //   label: "Combinations",
  //   allowedFilters: [],
  //   displayDefault: true,
  //   render: (value, record, index) => {
  //     return (
  //       <>
  //         {record?.combinations.length === 0 ? (
  //           <span>Not set to combine</span>
  //         ) : (
  //           record?.combinations.map((item, index) => (
  //             <>
  //               <span>
  //                 {item.replace("-", " ")}
  //                 {index !== record?.combinations.length - 1 ? "," : ""}
  //               </span>
  //               <br />
  //             </>
  //           ))
  //         )}
  //       </>
  //     );
  //   },
  // },
  // {
  //     "identifier": "variations.name",
  //     "label": "Variation Name",
  //     "allowedFilters": [
  //         {
  //             "id": "$eqc",
  //             "name": "Equals",
  //             "valueField": 'text'
  //         },
  //         {
  //             "id": "$nec",
  //             "name": "Not Equals",
  //             "valueField": 'text'
  //         },
  //         {
  //             "id": "$startsWithc",
  //             "name": "Starts With",
  //             "valueField": 'text'
  //         },
  //         {
  //             "id": "$endsWithc",
  //             "name": "Ends With",
  //             "valueField": 'text'
  //         },
  //         {
  //             "id": "$containsc",
  //             "name": "Contains",
  //             "valueField": 'text'
  //         },
  //         {
  //             "id": "$notContainsc",
  //             "name": "Does Not Contain",
  //             "valueField": 'text'
  //         },
  //     ],
  //     displayDefault: false,
  //     render: (value, record, index) => {
  //         return record.variations?.map((e) => e.name).join(", ");
  //     },
  // },
  // {
  //     "identifier": "inventory",
  //     "label": "Inventory",
  //     "allowedFilters": [],
  //     displayDefault: true,
  //     render: (value, record, index) => {
  //         let totalAvailableQuantity = 0;
  //         if (record.available_quantity !== null && record.available_quantity !== undefined) {
  //             totalAvailableQuantity = record.available_quantity;
  //         }
  //         return `${totalAvailableQuantity} in stock for ${record.variations.length} variants`;
  //     },
  // },
  // {
  //     "identifier": "brands.name",
  //     "label": "Brand",
  //     "allowedFilters": [
  //         {
  //             "id": "$eqc",
  //             "name": "Equals",
  //             "valueField": 'text'
  //         },
  //         {
  //             "id": "$nec",
  //             "name": "Not Equals",
  //             "valueField": 'text'
  //         },
  //         {
  //             "id": "$startsWithc",
  //             "name": "Starts With",
  //             "valueField": 'text'
  //         },
  //         {
  //             "id": "$endsWithc",
  //             "name": "Ends With",
  //             "valueField": 'text'
  //         },
  //         {
  //             "id": "$containsc",
  //             "name": "Contains",
  //             "valueField": 'text'
  //         },
  //         {
  //             "id": "$notContainsc",
  //             "name": "Does Not Contain",
  //             "valueField": 'text'
  //         },
  //     ],
  //     displayDefault: false,
  //     render: (value, record, index) => {
  //         return record?.brands?.[0]?.name;
  //     },
  // },
  // {
  //     "identifier": "categories.name",
  //     "label": "Category",
  //     "allowedFilters": [
  //         {
  //             "id": "$eqc",
  //             "name": "Equals",
  //             "valueField": 'text'
  //         },
  //         {
  //             "id": "$nec",
  //             "name": "Not Equals",
  //             "valueField": 'text'
  //         },
  //         {
  //             "id": "$startsWithc",
  //             "name": "Starts With",
  //             "valueField": 'text'
  //         },
  //         {
  //             "id": "$endsWithc",
  //             "name": "Ends With",
  //             "valueField": 'text'
  //         },
  //         {
  //             "id": "$containsc",
  //             "name": "Contains",
  //             "valueField": 'text'
  //         },
  //         {
  //             "id": "$notContainsc",
  //             "name": "Does Not Contain",
  //             "valueField": 'text'
  //         },
  //     ],
  //     displayDefault: true,
  //     render: (value, record, index) => {
  //         return record.categories?.map((category) => category.name).join(", ");
  //     },
  // },
  // {
  //     "identifier": "collections.name",
  //     "label": "Catalog",
  //     "allowedFilters": [
  //         {
  //             "id": "$eqc",
  //             "name": "Equals",
  //             "valueField": 'text'
  //         },
  //         {
  //             "id": "$nec",
  //             "name": "Not Equals",
  //             "valueField": 'text'
  //         },
  //         {
  //             "id": "$startsWithc",
  //             "name": "Starts With",
  //             "valueField": 'text'
  //         },
  //         {
  //             "id": "$endsWithc",
  //             "name": "Ends With",
  //             "valueField": 'text'
  //         },
  //         {
  //             "id": "$containsc",
  //             "name": "Contains",
  //             "valueField": 'text'
  //         },
  //         {
  //             "id": "$notContainsc",
  //             "name": "Does Not Contain",
  //             "valueField": 'text'
  //         },
  //     ],
  //     displayDefault: false,
  //     render: (value, record, index) => {
  //         return record.collections?.map((e) => e.name).join(", ");
  //     },
  // },
  // {
  //     "identifier": "types.name",
  //     "label": "Type",
  //     "allowedFilters": [
  //         {
  //             "id": "$eqc",
  //             "name": "Equals",
  //             "valueField": 'text'
  //         },
  //         {
  //             "id": "$nec",
  //             "name": "Not Equals",
  //             "valueField": 'text'
  //         },
  //         {
  //             "id": "$startsWithc",
  //             "name": "Starts With",
  //             "valueField": 'text'
  //         },
  //         {
  //             "id": "$endsWithc",
  //             "name": "Ends With",
  //             "valueField": 'text'
  //         },
  //         {
  //             "id": "$containsc",
  //             "name": "Contains",
  //             "valueField": 'text'
  //         },
  //         {
  //             "id": "$notContainsc",
  //             "name": "Does Not Contain",
  //             "valueField": 'text'
  //         },
  //     ],
  //     displayDefault: false,
  //     render: (value, record, index) => {
  //         return record?.types?.[0]?.name;
  //     },
  // },
  // {
  //     "identifier": "slug",
  //     "label": "Slug",
  //     "allowedFilters": [
  //         {
  //             "id": "$eqc",
  //             "name": "Equals",
  //             "valueField": 'text'
  //         },
  //         {
  //             "id": "$nec",
  //             "name": "Not Equals",
  //             "valueField": 'text'
  //         },
  //         {
  //             "id": "$startsWithc",
  //             "name": "Starts With",
  //             "valueField": 'text'
  //         },
  //         {
  //             "id": "$endsWithc",
  //             "name": "Ends With",
  //             "valueField": 'text'
  //         },
  //         {
  //             "id": "$containsc",
  //             "name": "Contains",
  //             "valueField": 'text'
  //         },
  //         {
  //             "id": "$notContainsc",
  //             "name": "Does Not Contain",
  //             "valueField": 'text'
  //         },
  //     ],
  //     displayDefault: false,
  //     render: (value, record, index) => {
  //         return record?.slug;
  //     },
  // },
  // {
  //     "identifier": "total_quantity",
  //     "label": "Total Quantity",
  //     "allowedFilters": [
  //         {
  //             "id": "$eq",
  //             "name": "Equals",
  //             "valueField": 'text'
  //         },
  //         {
  //             "id": "$ne",
  //             "name": "Not Equals",
  //             "valueField": 'text'
  //         },
  //         {
  //             "id": "$lt",
  //             "name": "Less than",
  //             "valueField": 'text'
  //         },
  //         {
  //             "id": "$gt",
  //             "name": "Greater than",
  //             "valueField": 'text'
  //         },
  //         {
  //             "id": "$lte",
  //             "name": "Less than or equal to",
  //             "valueField": 'text'
  //         },
  //         {
  //             "id": "$gte",
  //             "name": "Greater than or equal to",
  //             "valueField": 'text'
  //         },
  //         {
  //             "id": "$between",
  //             "name": "Is Between",
  //             "valueField": 'text'
  //         }
  //     ],
  //     displayDefault: false,
  //     render: (value, record, index) => {
  //         let totalQuantity = 0;
  //         if (record.total_quantity !== null && record.total_quantity !== undefined) {
  //             totalQuantity = record.total_quantity;
  //         }
  //         return `${totalQuantity}`;
  //     },
  // },
  // {
  //     "identifier": "available_quantity",
  //     "label": "Available Quantity",
  //     "allowedFilters": [
  //         {
  //             "id": "$eq",
  //             "name": "Equals",
  //             "valueField": 'text'
  //         },
  //         {
  //             "id": "$ne",
  //             "name": "Not Equals",
  //             "valueField": 'text'
  //         },
  //         {
  //             "id": "$lt",
  //             "name": "Less than",
  //             "valueField": 'text'
  //         },
  //         {
  //             "id": "$gt",
  //             "name": "Greater than",
  //             "valueField": 'text'
  //         },
  //         {
  //             "id": "$lte",
  //             "name": "Less than or equal to",
  //             "valueField": 'text'
  //         },
  //         {
  //             "id": "$gte",
  //             "name": "Greater than or equal to",
  //             "valueField": 'text'
  //         },
  //         {
  //             "id": "$between",
  //             "name": "Is Between",
  //             "valueField": 'text'
  //         }
  //     ],
  //     displayDefault: false,
  //     render: (value, record, index) => {
  //         let totalAvailableQuantity = 0;
  //         if (record.available_quantity !== null && record.available_quantity !== undefined) {
  //             totalAvailableQuantity = record.available_quantity;
  //         }
  //         return `${totalAvailableQuantity}`;
  //     },
  // },
  // {
  //     "identifier": "unavailable_quantity",
  //     "label": "Unavailable Quantity",
  //     "allowedFilters": [
  //         {
  //             "id": "$eq",
  //             "name": "Equals",
  //             "valueField": 'text'
  //         },
  //         {
  //             "id": "$ne",
  //             "name": "Not Equals",
  //             "valueField": 'text'
  //         },
  //         {
  //             "id": "$lt",
  //             "name": "Less than",
  //             "valueField": 'text'
  //         },
  //         {
  //             "id": "$gt",
  //             "name": "Greater than",
  //             "valueField": 'text'
  //         },
  //         {
  //             "id": "$lte",
  //             "name": "Less than or equal to",
  //             "valueField": 'text'
  //         },
  //         {
  //             "id": "$gte",
  //             "name": "Greater than or equal to",
  //             "valueField": 'text'
  //         },
  //         {
  //             "id": "$between",
  //             "name": "Is Between",
  //             "valueField": 'text'
  //         }
  //     ],
  //     displayDefault: false,
  //     render: (value, record, index) => {
  //         let totalUnavailableQuantity = 0;
  //         if (record.unavailable_quantity !== null && record.unavailable_quantity !== undefined) {
  //             totalUnavailableQuantity = record.unavailable_quantity;
  //         }
  //         return `${totalUnavailableQuantity}`;
  //     },
  // },
  // {
  //   identifier: "combinations",
  //   label: "Combinations",
  //   allowedFilters: [],
  //   displayDefault: true,
  //   render: (value, record, index) => {
  //     return <>{record?.combinations}</>;
  //   },
  // },
  {
    identifier: "total_times_used",
    label: "Used",
    allowedFilters: [
      {
        id: "$eq",
        name: "Equals",
        valueField: "text",
      },
      {
        id: "$ne",
        name: "Not Equals",
        valueField: "text",
      },
      {
        id: "$lt",
        name: "Less than",
        valueField: "text",
      },
      {
        id: "$gt",
        name: "Greater than",
        valueField: "text",
      },
      {
        id: "$lte",
        name: "Less than or equal to",
        valueField: "text",
      },
      {
        id: "$gte",
        name: "Greater than or equal to",
        valueField: "text",
      },
      {
        id: "$between",
        name: "Is Between",
        valueField: "text",
      },
    ],
    displayDefault: true,
    align: "center",
    render: (value, record, index) => {
      return <>{record?.total_times_used ? record?.total_times_used : 0}</>;
    },
  },
  {
    identifier: "expire_status",
    label: "Expire Status",
    allowedFilters: [
      {
        id: "$eq",
        name: "Equals",
        valueField: "select",
        selectOptions: {
          Ongoing: "Ongoing",
          Expired: "Expired",
        },
      },
    ],
    displayDefault: true,
    align: 'center',
    render: (value, record, index) => {
      return (
        <Tag
          color={value === "Expired" ? "red" : "blue"}
          className="status-tag"
        >
          {value}
        </Tag>
      );
    },
  },
  {
    identifier: "valid_from",
    label: "Start Date",
    allowedFilters: [
      {
        id: "equal",
        name: "Equals",
        valueField: "datepicker",
      },
      {
        id: "not_equal",
        name: "Not Equals",
        valueField: "datepicker",
      },
      {
        id: "less_than",
        name: "Less than",
        valueField: "datepicker",
      },
      {
        id: "greater_than",
        name: "Greater than",
        valueField: "datepicker",
      },
      {
        id: "less_than_or_equal_to",
        name: "Less than or equal to",
        valueField: "datepicker",
      },
      {
        id: "greater_than_or_equal_to",
        name: "Greater than or equal to",
        valueField: "datepicker",
      },
      {
        id: "between",
        name: "Is Between",
        valueField: "rangepicker",
      },
    ],
    align: "center",
    displayDefault: true,
    render: (value, record, index) => {
      return (
        <span>
          {/* {value ? dayjs(value).format("MMM DD, YYYY") : "Not Available"} */}

          {dayjs(value).format("MMM DD, YYYY HH:mm A")}
        </span>
      );
    },
  },
  {
    identifier: "valid_until",
    label: "End Date",
    allowedFilters: [
      {
        id: "equal",
        name: "Equals",
        valueField: "datepicker",
      },
      {
        id: "not_equal",
        name: "Not Equals",
        valueField: "datepicker",
      },
      {
        id: "less_than",
        name: "Less than",
        valueField: "datepicker",
      },
      {
        id: "greater_than",
        name: "Greater than",
        valueField: "datepicker",
      },
      {
        id: "less_than_or_equal_to",
        name: "Less than or equal to",
        valueField: "datepicker",
      },
      {
        id: "greater_than_or_equal_to",
        name: "Greater than or equal to",
        valueField: "datepicker",
      },
      {
        id: "between",
        name: "Is Between",
        valueField: "rangepicker",
      },
    ],
    displayDefault: true,
    align: "center",
    render: (value, record, index) => {
      return (
        <span>
          {/* {value ? dayjs(value).format("MMM DD, YYYY") : "Not Available"} */}
          {dayjs(value).format("MMM DD, YYYY HH:mm A")}
        </span>
      );
    },
  },
];

export default discounts;
